export default function Announcement() {
  return (
    <div className="h-8 w-full overflow-hidden bg-black shadow-[0px_1px_0px_0px_rgba(0,0,0,0.1)] backdrop-blur-[10px] backdrop-filter">
      <div className="container mx-auto flex h-full items-center justify-center gap-4">
        <p className="font-['Figtree'] text-xs leading-[18px] font-semibold whitespace-nowrap text-white">
          ⚠️ PSA: Some features may be unavailable as we are working on some changes to improve the service.{" "}
          <a
            href="https://blog.blidz.com/blidz-just-got-better-heres-how/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Read more
          </a>
        </p>
      </div>
    </div>
  );
}
